<div class="tile__status"
    [ngClass]="{ 'tile__status--active': tile.params.workingStatus,
        'tile__status--inactive': !tile.params.workingStatus }"
    data-testid="tile">
    <div class="icon-wrapper">
        <svg-icon src="/assets/img/icons/pump.svg"
                  *ngIf="!tile.params.workingStatus">
        </svg-icon>
        <svg-icon src="/assets/img/icons/pump_active.svg"
                  [class]="'rotate'"
                  *ngIf="tile.params.workingStatus">
        </svg-icon>
    </div>

    <div class="tile__subtitle tile__subtitle--flex"
        [attr.data-testid]="'tile-value-' + tile.id">
        <floating-subtitle class="tile__subtitle-row"
            [text]="(subtitle(576)) + ' ' + (tile.params.pumpNumber > 0
                ? tile.params.pumpNumber : '')">
        </floating-subtitle>
        <floating-subtitle [position]="'right'"
            class="tile__subtitle-row tile__subtitle-row--right font-bold font-15"
            [text]="subtitle(tile.params.txtId)">
        </floating-subtitle>
    </div>
    <div class="tile__setting cursor-pointer"
        [ngClass]="{ 'bg-light-shadow': tile.elementMenu.duringChange === 't' }"
        *ngIf="tile.elementMenu && tile.menuId !== 0"
        (click)="goControl()">
        <img ngSrc="/assets/img/icons/{{ getIconName() }}.svg"
             width="30" height="30" alt="" />
        <p class="tile__setting-alert font-12 color-light"
           *ngIf="tile.elementMenu.duringChange === 't'">
            {{ subtitle(3162) }}
        </p>
    </div>
</div>
